export const EMAIL_VERIFICATION_COPY = {
  gateTitle: 'Подтвердите почту',
  gateMessage:
    'Чтобы написать пользователю, подтвердите адрес электронной почты в настройках профиля.',
  gateReview: 'Чтобы оставить отзыв, подтвердите адрес электронной почты в настройках профиля.',
  gateComment:
    'Чтобы оставить комментарий, подтвердите адрес электронной почты в настройках профиля.',
  gateFallback: 'Чтобы продолжить, подтвердите адрес электронной почты в настройках профиля.',
  goToProfile: 'Перейти в профиль',
  notNow: 'Не сейчас',
  close: 'Закрыть',
  domainForbidden: 'Регистрация с этим почтовым доменом недоступна. Укажите другой адрес',
  domainForbiddenChange: 'Этот почтовый домен недоступен. Укажите другой адрес.',
  emptyCode: 'Введите код',
  invalidCode: 'Неверный код',
  expiredCode: 'Код устарел. Отправьте новый',
  invalidEmail: 'Введите корректный адрес электронной почты.',
  emailLabel: 'Почта',
  unverifiedStatus: 'Почта не подтверждена',
  verifiedStatus: 'Почта подтверждена',
  pendingStatus: 'Новая почта не подтверждена',
  vkStatus: 'Подтверждён через ВКонтакте',
  yandexStatus: 'Подтверждён через Яндекс',
  vkValue: 'Аккаунт ВКонтакте',
  yandexValue: 'Аккаунт Яндекс',
  changeEmail: 'Сменить почту',
  editEmail: 'Изменить почту',
  confirmEmail: 'Подтвердить почту',
  confirmCode: 'Подтвердить',
  cancelChange: 'Отмена',
  continueChange: 'Продолжить',
  newEmailLabel: 'Новая почта',
  newEmailPlaceholder: 'new-email@example.com',
  currentPasswordLabel: 'Текущий пароль',
  currentPasswordPlaceholder: 'Введите текущий пароль',
  emptyPassword: 'Введите текущий пароль',
  unverifiedHelper:
    'Подтвердите почту, чтобы отправлять личные сообщения, оставлять комментарии и отзывы.',
  verifiedHelper: 'Адрес подтверждён. Личные сообщения, комментарии и отзывы доступны.',
  providerHelper: 'Дополнительное подтверждение почты не требуется.',
  codeSentLabel: 'Код отправили на',
  resendReady: 'Отправить код ещё раз',
  resendWait: 'Отправить повторно через',
  confirmedToast: 'Почта подтверждена',
  codeResentToast: 'Новый код отправлен',
  changeCodeSentToast: 'Код отправлен на новый адрес',
  sendFailed: 'Не удалось отправить код',
  confirmFailed: 'Не удалось подтвердить почту',
  changeFailed: 'Не удалось сменить почту',
} as const;

export const EMAIL_GATE_DESCRIPTION = {
  message: EMAIL_VERIFICATION_COPY.gateMessage,
  review: EMAIL_VERIFICATION_COPY.gateReview,
  comment: EMAIL_VERIFICATION_COPY.gateComment,
} as const;
